{
  "name": "quality-assurance",
  "hostname": "qa.serveport.com",
  "default": null,
  "development": true,
  "production": false,
  "applicationName": "ServePort",
  "sourceVersion": "94961ca1555d0485d35917c2e19a1b4b445311e9",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.qa.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.qa.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.qa.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.qa.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_test_sXNkfHf4SoQCOwMv6G26jnOd00AaAlGrWM"
  },
  "auth0": {
    "authorityRoot": "safarilaw-qa.auth0.com",
    "clientId": "BKDju9RPeR0vRALU2mkwOMOCAgI4ceXl",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 0,
    "inactivityWarning": 0
  },
  "statusApp": {
    "apiRootUrl": "https://@.qa.serveport.com/_api/maintenance/",
    "code": "o33J6l83lG-HUvterNqfuIAfeJcqvqnNN2s-bvpGqEtvAzFuTio3nQ==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": true,
    "devExceptions": true,
    "inputRelativeValidation": true,
    "enableServiceOfProcessBusinessHours": true
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "6045357b-2709-490a-be56-96229bca203a"
    },
    "appInsights": {
      "connectionString": "InstrumentationKey=63b5b902-5193-4a8a-b14e-db55e9eee613;IngestionEndpoint=https://eastus-5.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=85ed659e-c56e-465e-bd8b-485b1b528fe2"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "showSwWarning": true,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self",
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 20
    },
    "reports": {
      "key": "Z70R-XG6J5I-274219-0W0Y0F-734Y3H-5I460R-0H445W-4F6S27-2G5S1J-4P291I-2E5N"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
